module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-2.55346cf4.mp3";